import { Builder } from '@builder.io/react';
import { Link } from 'react-router-dom';

const AnnualReportWidget = ({
  title,
  pdfLink,
  img,
  alt,
  openInNewTab = true,
  containerClasses = '',
  linkClasses = '',
  imageClasses = '',
  titleClasses = '',
  imageContainerClasses = '',
}) => {
  return (
    <div className={`p-2 xl:p-4 overflow-hidden transition-all hover:-translate-y-4 ${containerClasses}`}>
      <Link to={pdfLink} target={openInNewTab ? '_blank' : '_self'} rel={openInNewTab ? 'noopener noreferrer' : ''} className={linkClasses}>
        <div
          className={`overflow-hidden rounded-lg sm:rounded-xl border-[#14A2DC] border-[3px] drop-shadow-[-4px_5px_0px_rgba(220,220,220,1)] shadow-md md:rounded-[15px] transition-all duration-300 hover:shadow-md bg-[#e3e3e3] ${imageContainerClasses}`}
        >
          <img src={img} alt={alt} className={`w-full transition-all duration-300 scale-100 hover:scale-110 ${imageClasses}`} />
        </div>
        <p className={`mb-5 text-center text-sm lg:text-lg mt-2 ${titleClasses}`}>{title}</p>
      </Link>
    </div>
  );
};

Builder.registerComponent(AnnualReportWidget, {
  name: 'AnnualReportWidget',
  inputs: [
    {
      name: 'title',
      type: 'text',
      defaultValue: 'Annual Report 2024',
    },
    {
      name: 'pdfLink',
      type: 'file',
      allowedFileTypes: ['.pdf'],
    },
    {
      name: 'img',
      type: 'file',
      allowedFileTypes: ['.jpg', '.jpeg', '.png', '.webp'],
    },
    {
      name: 'alt',
      type: 'text',
      defaultValue: 'Annual Report Cover',
    },
    {
      name: 'openInNewTab',
      type: 'boolean',
      defaultValue: true,
    },
    {
      name: 'containerClasses',
      type: 'text',
      helperText: 'Tailwind classes for the outer container',
    },
    {
      name: 'linkClasses',
      type: 'text',
      helperText: 'Tailwind classes for the <Link>',
    },
    {
      name: 'imageContainerClasses',
      type: 'text',
      helperText: 'Tailwind classes for the image wrapper',
    },
    {
      name: 'imageClasses',
      type: 'text',
      helperText: 'Tailwind classes for the <img> element',
    },
    {
      name: 'titleClasses',
      type: 'text',
      helperText: 'Tailwind classes for the title <p>',
    },
  ],
});

export default AnnualReportWidget;
